import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-lyrk",
  "use": "icon-lyrk-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" id=\"icon-lyrk\"><path d=\"M512 32l480 256h-64v640a64 64 0 0 1-64 64h-96v-160h64l3.744-0.224A32 32 0 0 0 832 768h-64v-160h-256v384H160a64 64 0 0 1-64-64V288H32l480-256z m182.624 649.376a32 32 0 0 1 2.656 42.24l-2.656 3.008L653.248 768H768v64h-114.752l41.376 41.376a32 32 0 0 1 2.656 42.24l-2.656 3.008a32 32 0 0 1-42.24 2.656l-3.008-2.656-96-96a32 32 0 0 1-2.656-42.24l2.656-3.008 96-96a32 32 0 0 1 45.248 0zM288 288a32 32 0 0 0-32 32v126.72L230.4 432a32 32 0 1 0-32 55.424l34.72 20.064 15.552 46.624a32 32 0 0 0 30.368 21.888H416a32 32 0 0 0 32-32v-128a32 32 0 0 0-32-32h-96v-64a32 32 0 0 0-32-32z\" fill=\"#4F79FF\" p-id=\"7488\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/assets/svg/lyrk.svg
// module id = YQq9
// module chunks = 10